var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "main-article",
              "comment-highlights": _vm.commentHighlights,
              "text-count-class": "inner",
              "text-counts": _vm.textCounts,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("section", { staticClass: "mlr10" }, [
        _c("div", { staticClass: "fll mt5 intro-left" }, [
          _c("h2", {
            staticClass: "fs15 fwB pega-pre-wrap",
            staticStyle: { "line-height": "1.6" },
            attrs: {
              id: _vm.targetIdMap.mainArticle.title,
              "data-test": "title",
            },
            domProps: { textContent: _vm._s(_vm.title) },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "fs13 mt15 pega-pre-wrap",
            attrs: {
              id: _vm.targetIdMap.mainArticle.body,
              "data-test": "body",
            },
            domProps: { textContent: _vm._s(_vm.body) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flr intro-right" },
          [
            _c("figure", [
              _vm.photoData
                ? _c("img", {
                    attrs: {
                      id: _vm.targetIdMap.mainArticle.photo,
                      src: _vm.getPhotoUrl(_vm.photoData),
                      "data-test": "photo",
                    },
                    on: {
                      load: function ($event) {
                        return _vm.$emit("onLoadImage")
                      },
                      error: function ($event) {
                        return _vm.$emit("onLoadImage")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.caption
                ? _c("figcaption", {
                    staticClass: "fs11 pt10 pega-pre-wrap",
                    attrs: {
                      id: _vm.targetIdMap.mainArticle.caption,
                      "data-test": "caption",
                    },
                    domProps: { textContent: _vm._s(_vm.caption) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("job-appeal-point-pc", { attrs: { "pr-codes": _vm.prCodes } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }